import React from "react";
import "../../Css/NotFound.css"
const NotFound = () => (
  <>
    <div className="notFound">

      <div className='stars'></div>
      <div className='stars2'></div>
      <div className='stars3'></div>
      <div className='title'>
        <span className="text404">
          404
        </span>
        <br />
        <span>
          PAGE NOT FOUND
          <a href="/">Go HOME</a>
        </span>
      </div>
    </div>

  </>

);

export default NotFound;